import { emailConstants } from "../../../../constants/email/email.constants";
import { deepClone } from "../../../../helpers/objectHelper";
/* import { emailHelper } from "../../../../cms/areas/email/helper/email.helper"; */

const defaultEmail = {
  communicationId: 0,
  eventId: 0,
  type: 'EMAIL',
  name: "default email",
  subject: 'default subject',
  previewText: 'default previewText',
  fromName: 'Jirango',
  fromAddr: 'support@inadra.se',
  isSavable: false,
  elements: [],
  selectedElement: null,
  elements: [],
  body: '',
  submitError: false,
  fetched: null,
  sent: false
};

export function email(state = defaultEmail, action) {
  switch (action.type) {
    case emailConstants.GET_EMAIL_REQUEST:
      return {
        ...state,
        loading: true
      };
    case emailConstants.REMOVE_EMAIL_ELEMENT:
      const cleanedElements = state.elements.filter(e => e.id !== action.element.id)
      return {
        ...state,
        elements: cleanedElements,
        selectedElement: null,
        isSavable: true
      };
    case emailConstants.GET_EMAIL_SUCCESS:
      const { bodyJson } = action.email;
      return {
        ...state,
        ...action.email,
        elements: bodyJson ? JSON.parse(bodyJson) : [],
        fetched: action.email.updated
      };
      
    case emailConstants.GET_EMAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
      case emailConstants.GETALL_EMAIL_REQUEST:
        return {
          ...state,
          loading: true
        };
    
      case emailConstants.GETALL_EMAIL_SUCCESS:
        return {
          ...state,
          emails: action.emails,
        };
      case emailConstants.GETALL_EMAIL_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.error
        };


    case emailConstants.UPDATE_EMAIL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case emailConstants.EMAIL_SENT:
      return {
        ...state,
        sent: false,
      };

    case emailConstants.UPDATE_EMAIL_SUCCESS:
      return {
        ...state,
        ...action.email,
        body: action.email.body,
        loading: false,
        isSavable: false,
        selectedElement: null,
    /*     elements: action.email.bodyJson ? emailHelper.sortElements(JSON.parse(action.email.bodyJson ), true) : [], */
        fetched: action.email.updated

      };
    case emailConstants.UPDATE_EMAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case emailConstants.SEND_TEST_REQUEST:
      return {
        ...state,
        sending: true,
      };

    case emailConstants.SEND_TEST_SUCCESS:
      return {
        ...state,
        sending: false,
        sent: true
      };
    case emailConstants.SEND_TEST_FAILURE:
      return {
        ...state,
        sending: false,
        error: action.error
      };
    case emailConstants.SOFT_UPDATE_EMAIL:
      return {
        ...state,
        ...action.email,
        isSavable: true
      };
    case emailConstants.DESELECT_EMAIL_ELEMENT:
      return {
        ...state,
        selectedElement: null
      }
    case emailConstants.SELECT_EMAIL_ELEMENT:
      return {
        ...state,
        selectedElement: action.element
      }
    case emailConstants.UPDATE_EMAIL_ELEMENT:
      let newElements = Array.from(state.elements);
      let newSelectedElement = state.selectedElement;
      if (Array.isArray(action.element)) {
        /*  action.element.map(ae => {
           if (newElements.length < 1) { */
        newElements = Array.from(action.element);
        /*   } else {
            newElements = newElements.map(el => {
              if (el.contentId == ae.contentId) {
                let newEl = deepClone(ae);
                if (
                  state &&
                  state.selectedElement &&
                  state.selectedElement.contentId === el.contentId
                ) {
                  newSelectedElement = newEl;
                }
                return newEl;
              } else return el;
            });
          }
        }); */
      } else {
        newElements = newElements.map(el => {
          if (el.id == action.element.id) {
            let newEl = deepClone(action.element);
            if (
              state &&
              state.selectedElement &&
              state.selectedElement.id === el.id
            ) {
              newSelectedElement = newEl;
            }
            return newEl;
          } else return el;
        });
      }
      return {
        ...state,
        elements: newElements,
        selectedElement: newSelectedElement,
        isSavable: action.isSavable
      };
    default:
      return state;
  }
}
